import { apiClient } from '@app/api';
import { useAuditReportsGetGipMetadataCustomFields } from '@mi-front/api-v2';
import { useQuery } from '@tanstack/react-query';
import { useGipFormNewApi } from './useGipFormNewApi';

/**
 * Custom field keys for the GIP form. Legacy API is station-scoped; the new
 * audit-reports endpoint is global (no query params).
 */
export function useGipCustomFieldsQuery(params: { stations: string[] }) {
  const useNewApi = useGipFormNewApi();

  const legacy = useQuery({
    queryKey: ['gip-report-CustomFields', params],
    queryFn: () =>
      apiClient.audit.gipFetchCustomFields(params).then((values) => values.filter((v) => !!v)),
    enabled: !useNewApi,
  });

  const neu = useAuditReportsGetGipMetadataCustomFields({
    query: {
      enabled: useNewApi,
      select: (customFields) => customFields.filter((v) => !!v),
    },
  });

  return useNewApi ? neu : legacy;
}
